var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultItemKit = function SvgLivemapSearchresultItemKit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#66B3C0",
    strokeWidth: "3%",
    d: "M13.076 6.565a6.435 6.435 0 0 0 1.434-3.17.392.392 0 0 0-.388-.4h-6.19a.392.392 0 0 0-.388.4 6.417 6.417 0 0 0 1.435 3.171C7.104 8.505 5 11.235 5 13.738c0 2.9 2.7 5.261 6.029 5.261s6.029-2.36 6.029-5.261c-.003-2.504-2.108-5.234-3.982-7.173zm.592-2.774a6.491 6.491 0 0 1-1.3 2.393H9.68a6.491 6.491 0 0 1-1.3-2.393zm-2.642 14.417c-2.895 0-5.25-2.006-5.25-4.47 0-2.409 2.389-5.225 3.9-6.761h2.708c1.507 1.536 3.894 4.352 3.894 6.761 0 2.464-2.355 4.469-5.249 4.469z"
  })));
};
export default SvgLivemapSearchresultItemKit;